export class UserState {
  constructor() {
    this.attorneyData = '';
    this.lawSchools = [];
    this.clientNames = [];
  }
}
